export default __webpack_public_path__ + "static/race-day-kids-square-916fa944635f8a5d33a7282d415c3aa8.png";